import { render, staticRenderFns } from "./defectForm.vue?vue&type=template&id=1804978c&scoped=true"
import script from "./defectForm.vue?vue&type=script&lang=js"
export * from "./defectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804978c",
  null
  
)

export default component.exports